import { StateUtils } from "@spartacus/core";
import {MULTI_CART_DATA} from "@spartacus/cart/base/core";

export const GONVARRI_CART_UPDATE_ENTRY = "[Cart-entry] Gonvarri Update Entry Success";

export class GonvarriCartUpdateEntry extends StateUtils.EntityProcessesDecrementAction {
  override readonly type = GONVARRI_CART_UPDATE_ENTRY;
  constructor(public payload: {
    entryNumber: string,
    unitType: string,
    curQuantity: number,
    customLength: number,
    productCode: string,
    quantity: number,
    userId: string,
    cartId: string
  }) {
    super(MULTI_CART_DATA, payload.cartId);
  };
}
